import { IconV2AttachmentOutline } from '@icons/IconV2AttachmentOutline'
import { IconTransformOutline } from '@icons/IconTransformOutline'
import { Badge } from '@/components/shadcn/badge'
import { Button } from '@/components/shadcn/button'
import { RestSchemas } from '@/contexts/QueryProvider'
import { stateMap } from '../stateMap'
import { format } from 'date-fns'
import { Blurb } from './Blurb'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { useDownloadFile } from '../../TemplatesV2/useDownloadFile'
import { MessagesStorageStorageFileType } from '@/util/enums'
import { IconV2CalendarOutline } from '@icons/IconV2CalendarOutline'

type LogItem = RestSchemas['Messages.DataAssets.TDataAssetActivity']

export function LogItemContent({ date, user, state, file_name, blurb, activity, url }: LogItem) {
  const validState = state in stateMap ? (state as keyof typeof stateMap) : 'None'
  const badgeVariant = stateMap[validState].variant ?? 'outline'
  const { mutate: downloadFile, isPending } = useDownloadFile()

  const handleDownloadFile = () => {
    if (!url) return
    downloadFile({ url, fileName: file_name, fileType: MessagesStorageStorageFileType.Result })
  }

  return (
    <>
      <div className="mt-1 flex items-center gap-2 text-sm">
        <IconV2CalendarOutline className="h-4 w-4" />
        <span>{format(new Date(date), 'PPp')}</span>
      </div>
      {activity === 'Comment' ? (
        <>
          <div className="flex items-center gap-2">
            <Badge variant="outline" className="rounded-full border-muted-foreground bg-muted text-muted-foreground">
              Reply
            </Badge>
            <p>
              from <span className="text-base font-semibold">{user}</span>
            </p>
          </div>
          <Blurb blurb={blurb} />
        </>
      ) : (
        <>
          <div className="flex items-center gap-2">
            <Badge variant={badgeVariant} className="rounded-full">
              {stateMap[validState].name}
            </Badge>
            <p className="text-base font-semibold">{user}</p>
          </div>
          {file_name && url ? (
            <TooltipButton tooltip={`Download: ${file_name}`}>
              <Button
                variant="ghost"
                className="h-auto w-full justify-start truncate p-0"
                onClick={handleDownloadFile}
                disabled={isPending}
              >
                <IconV2AttachmentOutline size={16} className="ml-1 flex-shrink-0 text-foreground" />
                <span className="ml-1 max-w-[480px] truncate font-light underline underline-offset-2">{file_name}</span>
                {isPending && <IconTransformOutline size={16} className="ml-1 flex-shrink-0 text-foreground" />}
              </Button>
            </TooltipButton>
          ) : null}
          <Blurb blurb={blurb} />
        </>
      )}
    </>
  )
}
